import type { OrderProduct } from "../OrderProduct.js";

export interface OrderProductPriceSettings {
	applyTax: boolean;
}

export function getPriceOfOrderProduct(
	{ info, quantity }: Pick<OrderProduct, "info" | "quantity">,
	{ applyTax }: OrderProductPriceSettings,
): {
	taxRate: number;
	unitWithoutTax: number;
	unitWithTax: number;
	withoutTax: number;
	withTax: number;
} {
	const unitWithoutTax = info.price.withoutTax;
	const unitWithTax = applyTax ? info.price.withTax : unitWithoutTax;
	const totalWithoutTax = unitWithoutTax * quantity;
	const totalWithTax = applyTax ? unitWithTax * quantity : totalWithoutTax;

	return {
		taxRate: applyTax ? info.price.taxRate : 0,
		unitWithoutTax,
		unitWithTax,
		withoutTax: totalWithoutTax,
		withTax: totalWithTax,
	};
}
